/**
 * Sticky Add to Cart Script
 * 
 * This script creates a sticky add to cart bar that appears on product pages.
 * It replicates the behavior of the original add to cart button.
 * 
 * Note: Button state updates are now handled in the global.js toggleAddButton method
 * to ensure perfect synchronization between the original and sticky buttons.
 */
document.addEventListener('DOMContentLoaded', function() {
  // Only initialize on product pages
  if (document.querySelector('.template-product') === null && 
      !document.body.classList.contains('page-product')) {
    return;
  }

  // Add body class for styling
  document.body.classList.add('product-page');
  
  // Basic setup and element selection
  const stickyAddToCartBtn = document.getElementById('StickyAddToCart');
  
  // Try different selectors for the original button
  let originalAddBtn = document.querySelector('button[name="add"]') ||
                       document.querySelector('.product-form__submit') ||
                       document.querySelector('.add-to-cart');
  
  // Get the original button by ID if available
  const productSectionId = getProductSectionId();
  if (productSectionId) {
    const idButton = document.getElementById(`ProductSubmitButton-${productSectionId}`);
    if (idButton) originalAddBtn = idButton;
  }
  
  if (!stickyAddToCartBtn) {
    console.warn('Sticky add to cart: Could not find sticky button');
    return;
  }
  
  if (!originalAddBtn) {
    console.warn('Sticky add to cart: Could not find original button, sticky will still display');
  }
  
  // Clear any existing classes or states that might make the button appear clicked
  stickyAddToCartBtn.classList.remove('loading', 'active', 'clicked');
  
  // Make sure the spinner is hidden
  const spinner = stickyAddToCartBtn.querySelector('.loading-overlay__spinner');
  if (spinner) spinner.classList.add('hidden');
  
  // Initialize UI state (initial sync)
  updateStickyButton();
  
  // Add click handler to the sticky button
  stickyAddToCartBtn.addEventListener('click', handleStickyButtonClick);
  
  // Make sure the sticky cart is visible on page load
  const stickyContainer = document.querySelector('.sticky-add-to-cart');
  if (stickyContainer) {
    stickyContainer.style.display = 'block';
  }
  
  /**
   * Helper Functions
   */
  
  // Get the product section ID
  function getProductSectionId() {
    const productInfo = document.querySelector('product-info');
    if (productInfo && productInfo.dataset.section) return productInfo.dataset.section;
    
    // Try to get section ID from other elements
    const sectionElement = document.querySelector('[data-section]') || 
                          document.querySelector('[data-section-id]') ||
                          document.querySelector('[id^="MainProduct-"]');
                          
    if (sectionElement) {
      if (sectionElement.dataset.section) return sectionElement.dataset.section;
      if (sectionElement.dataset.sectionId) return sectionElement.dataset.sectionId;
      if (sectionElement.id && sectionElement.id.startsWith('MainProduct-')) {
        return sectionElement.id.replace('MainProduct-', '');
      }
    }
    
    return '';
  }
  
  // Handle initial button sync
  function updateStickyButton() {
    if (!originalAddBtn) return;
    
    // Update price in sticky cart if available
    updateStickyPrice();
  }
  
  // Update the price displayed in the sticky cart
  function updateStickyPrice() {
    const priceElement = document.querySelector('.sticky-add-to-cart__price');
    if (!priceElement) return;
    
    // Try different selectors for price - themes can vary
    const priceSelectors = [
      '.price .price__regular .price-item--regular',
      '.current-price .price-item--regular',
      '.current-price .money',
      '.price-item--regular',
      '.price .money'
    ];
    
    let currentPrice;
    for (const selector of priceSelectors) {
      currentPrice = document.querySelector(selector);
      if (currentPrice) break;
    }
    
    if (currentPrice) {
      priceElement.textContent = currentPrice.textContent.trim();
    }
  }
  
  // Handle sticky button click - trigger the original button
  function handleStickyButtonClick(e) {
    e.preventDefault();
    
    if (this.disabled || this.getAttribute('aria-disabled') === 'true') {
      return;
    }
    
    // Show loading spinner
    this.classList.add('loading');
    const spinner = this.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');
    
    // Click the original button to trigger the same behavior
    if (originalAddBtn) {
      originalAddBtn.click();
    } else {
      // If we can't find the original button, try to find the form and submit it
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.submit();
      }
    }
    
    // Hide spinner after a delay
    setTimeout(() => {
      this.classList.remove('loading', 'active', 'clicked');
      if (spinner) spinner.classList.add('hidden');
    }, 1000);
  }
});
